import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import SdkAgGrid from '@client-shared/ui-agGrid';

import { CACHE_BLOCK_SIZE, serverSideColumnOptions } from './constants';

const ServerSideAgGrid = ({ columnDefs, ...rest }) => {
  const columnDefinitions = useMemo(
    () =>
      columnDefs.map(columnDef => ({
        ...serverSideColumnOptions,
        ...columnDef,
      })),
    [columnDefs]
  );

  return (
    <SdkAgGrid
      columnDefs={columnDefinitions}
      rowModelType="serverSide"
      cacheBlockSize={CACHE_BLOCK_SIZE}
      {...rest}
    />
  );
};

ServerSideAgGrid.propTypes = {
  columnDefs: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default ServerSideAgGrid;
